import {useRef, useState, useEffect} from "react"
import {useParams} from 'react-router-dom'

import Paper from '@material-ui/core/Paper'
import TextField from "@base/Inputs/Text"
import RadioButtonsGroup from "@base/Inputs/Radio"
import Toast from "@base/Toast";
import BuscaEscola from '@base/Inputs/BuscaEscola'
import {Grid} from '@material-ui/core';

import Title from "@base/Title"
import Subtitle from "@base/Subtitle"
import {envelopePostalMask} from '@helpers/MaskHelper';
import {ProcessoResolver} from "@helpers/ProcessoHelper"
import MultipleSelectFile from "../../base/Inputs/MultipleSelectFile/MultipleSelectFile";
import RegistroArquivosSelecionados from "./RegistroArquivosSelecionados";
import ListagemArquivosRegistrados from "./ListagemArquivosRegistrados";
import useStyles from "./Style";

import useOrigens from "@hooks/enums/useOrigens";

export const InformarCartaoResposta = () => {

  const [horaUltimoRefresh, setHoraUltimoRefresh] = useState();
  const [horaUltimoRefreshSelecionados, setHoraUltimoRefreshSelecionados] = useState();

  const [escolaSelecionada, setEscolaSelecionada] = useState({});
	const [inepInformado, setInepInformado] = useState("");
  const [objetoPostalInformado, setObjetoPostalInformado] = useState("");

  const listagemOrigem = useOrigens();
  const origensOptions = listagemOrigem.data.filter(d => d.value !== "APLICATIVO");

  const [origem, setOrigem] = useState("");
  const [arquivoCartao, setArquivoCartao] = useState([]);
  const classes = useStyles();
	const params = useParams();
	const processo = ProcessoResolver(params.processo);

	const toastRef = useRef(null);

	const pageName = `Recebimento de Cartões`;

	const carregaInformacoesDaEscola = (escola) => {
		setInepInformado(escola.codigoInep);
		setEscolaSelecionada(escola);
		setArquivoCartao([])
	}

  useEffect(() => setHoraUltimoRefresh(new Date()), [arquivoCartao]);

	return (
		<>
			<Toast ref={toastRef} />

			<Title>{pageName}</Title><br />

			<BuscaEscola
				autoFocus
				manterinep
				permiteeticket
				processo={processo}
				aoencontrar={carregaInformacoesDaEscola}
				aonaoencontrar={() => {}}
			/>

			<br/>
			{inepInformado &&
				<>
					<Grid container spacing={2}>
						<Grid item sm={12}>
							<Paper className={classes.wrapper} elevation={2}>
								<Subtitle>
									Informe os Dados do Cartão
								</Subtitle>

								<Grid alignItems="center" container spacing={3}>
									<Grid item >
									<RadioButtonsGroup
										field="Origem"
										name="origem"
										options={origensOptions}
										value={origem}
										onChange={(e) =>{
											setObjetoPostalInformado("");
											 setOrigem(e.target.value);
										}}
									/>
									</Grid>

								</Grid>

								<Grid alignItems="center" container spacing={3}>
									{ origem === "ENVELOPE" &&
									<Grid item sm={3}>
										<TextField autoFocus label="Código do Objeto Postal" value={objetoPostalInformado} onChange={(e) => setObjetoPostalInformado(envelopePostalMask(e.target.value))} />
									</Grid>
									}

                  {origem &&
									<Grid item sm={9}>
										<MultipleSelectFile
											arquivo={arquivoCartao}
											handleUpload={setArquivoCartao}
											mensagemSobreRestricoes="Somente são permitidos arquivos jpg, jpeg e png. Arquivos com outras extensões serão ignorados e não aparecerão para upload."
                      onClick={() => setHoraUltimoRefreshSelecionados(new Date())}
                    />
									</Grid>}

								</Grid>
                <Grid alignItems="center" item>
                  {arquivoCartao.length > 0 &&
                    <RegistroArquivosSelecionados processo={processo}
                                                  origem={origem}
                                                  escola={escolaSelecionada}
                                                  numeroObjetoPostal={objetoPostalInformado}
                                                  arquivos={arquivoCartao}
                                                  onRegistrar={() => setHoraUltimoRefresh(new Date())}
                                                  refresh={horaUltimoRefreshSelecionados}
                    />}
                </Grid>
							</Paper>
						</Grid>
					</Grid>
					<br/>
            <ListagemArquivosRegistrados refresh={horaUltimoRefresh} inep={inepInformado} processo={processo}/>
				</>
			}
		</>
	)
}

export default InformarCartaoResposta;
